import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import ReportsBreadCrumbs from 'src/pages/Reports/ReportsBreadCrumbs';
import ReportsList from './ReportsList';
import ReportOffPeriod from '../../components/reportOffPeriod/ReportOffPeriod';
import ReportActionsMain from '../../components/reportActions/ReportActionsMain';
import FactoryReport from '../../components/reportFactory/FactoryReport';
import ReportKPIMain from '../../components/reportKPI/ReportKPI';

function ReportsMainGop() {
  const { reportID } = useParams();

  const path = reportID === '1' ? ['Отчет по заводу'] : reportID === '2' ? ['Отчет по выполненным действиям'] : reportID === '3' ? ['Отчет по закрытию периода самооценки'] : reportID === '4' ? ['Отчет по KPI'] : [];

  const [crumbs, setCrumbs] = useState<string[]>(path);

  const handleSetCrumbs = (newCrumb: string) => {
    setCrumbs(() => [newCrumb]);
  };

  useEffect(() => {
    if (!reportID) {
      setCrumbs([]);
    }
  }, [reportID]);

  return (
    <>
      {reportID ? (
        <>
          {reportID === '1' && <FactoryReport/>}
          {reportID === '2' && <ReportActionsMain/>}
          {reportID === '3' && <ReportOffPeriod />}
          {reportID === '4' && <ReportKPIMain />}
        </>
      ) : (
        <>
          <ReportsBreadCrumbs reportsCrumbs={crumbs} />
          <ReportsList onSetCrumbs={handleSetCrumbs} />
        </>
      )}
    </>
  );
}

export default ReportsMainGop;
